import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/views/main/router.js'


//预览简历
import yljl from '@/views/wdjl/pages/yl.vue'

// import Yl from '@/apps/yl/router.js'
// import Errorpage from '@/apps/Error/router.js'

// import home from '@/view/home.vue'
Vue.use(Router)

export default new Router({
  routes: [
    Main,
      {
        path: '/yljl',
        name: 'yljl',
        component: yljl,
      }
  ]
})



// WEBPACK FOOTER //
// ./src/utils/router.js